import { Component } from '@angular/core';

@Component({
  templateUrl: 'nolocalinfo.template.html',
})
export class NoLocalInfoComponent {}
